import { ImageWraper } from '@components/shared/wraper/ImageWraper'

type Props = {
  src: string
  alt: string
  width: number
  height: number
}

export const RecommendGenreCardImage = (props: Props): JSX.Element => (
  <div className="w-[19vw] lg:w-[6.6vw]">
    <ImageWraper {...props} />
  </div>
)
